import ProductTypeStep from './TypeStep';

export default ProductTypeStep;
